module.exports = __webpack_public_path__ + "static/media/360esolutions-logo.d60d4251.png";